"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[142],{

/***/ 11653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ base_AmountInput; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
;// CONCATENATED MODULE: ./src/components/base/CustomNumericFormat.tsx



const CustomNumericFormat = /*#__PURE__*/ react.forwardRef(function NumericFormatCustom(props, ref) {
    const { onChange , ...other } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
        ...other,
        getInputRef: ref,
        onChange: (event)=>{
            onChange({
                ...event,
                target: {
                    ...event.target,
                    name: props.name,
                    value: event.target.value.replaceAll(",", "")
                }
            });
        },
        thousandSeparator: true,
        valueIsNumericString: true
    });
});
/* harmony default export */ var base_CustomNumericFormat = (CustomNumericFormat);

// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(13970);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 3 modules
var Avatar = __webpack_require__(12485);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ErrorOutline.js
var ErrorOutline = __webpack_require__(32141);
// EXTERNAL MODULE: ./src/utils/number-helpers.ts
var number_helpers = __webpack_require__(72199);
;// CONCATENATED MODULE: ./src/components/base/AmountInput.tsx






const AmountInput = (param)=>{
    let { amount , setAmount , tokenAvatar , tokenSymbol , checkStakingBalance =false , balance =0 , minAmount =0  } = param;
    const [error, setError] = (0,react.useState)("");
    const handleAmountChange = (event)=>{
        const value = event.target.value;
        setAmount(value.toString());
        if (Number(value) < 0) {
            setError("Amount cannot be negative");
        } else if (value === "") {
            setError("Amount is required");
        } else if (Number(value) < minAmount) {
            setError("Min amount: ".concat(minAmount, " ").concat(tokenSymbol));
        } else if (Number(value) > balance) {
            setError("Insufficient balance");
        } else {
            setError("");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "px-4 pb-4 bg-transparent-light-purple-4 rounded-lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    gap: 1,
                    className: "py-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "text-white font-dm_mono_regular text-xs-2 sm:text-sm lg:text-base",
                            children: "Amount"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            direction: "row",
                            gap: 1,
                            height: "2.5rem",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, {
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    inputComponent: base_CustomNumericFormat,
                                    placeholder: "Enter amount",
                                    className: "p-0 p-xl font-dm_mono_regular",
                                    fullWidth: true,
                                    value: amount,
                                    onChange: handleAmountChange,
                                    inputProps: {
                                        style: {
                                            color: "#ffffff"
                                        }
                                    },
                                    sx: {
                                        "& .MuiInputBase-input": {
                                            fontSize: {
                                                xs: "14px",
                                                sm: "16px",
                                                lg: "20px"
                                            },
                                            lineHeight: {
                                                xs: "20px",
                                                sm: "24px",
                                                lg: "28px"
                                            }
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                border: "none"
                                            },
                                            "&:hover fieldset": {
                                                border: "none"
                                            },
                                            "&.Mui-focused fieldset": {
                                                border: "none"
                                            }
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    gap: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            src: tokenAvatar,
                                            alt: tokenSymbol,
                                            sx: {
                                                width: 32,
                                                height: 32
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "text-white text-xs-2 sm:text-sm font-dm_mono_regular",
                                            children: tokenSymbol
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    className: "w-full ",
                    style: {
                        height: "2px",
                        backgroundColor: error ? "#ff7171" : "rgba(255, 255, 255, 0.08)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            justifyContent: "space-between",
                            direction: "row",
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "text-white/50 font-normal text-xs-2 sm:text-sm font-dm_mono_regular",
                                            children: checkStakingBalance ? "Staking balance:" : "Available balance:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            className: "text-white text-xs-2 sm:text-sm font-medium font-dm_mono_regular",
                                            children: [
                                                "\xa0",
                                                (0,number_helpers/* format */.WU)(balance, true),
                                                "\xa0",
                                                tokenSymbol
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "text-white/50 text-xs-2 sm:text-sm font-normal font-dm_mono_regular underline cursor-pointer",
                                    onClick: ()=>setAmount(balance.toString()),
                                    children: "Enter max"
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            className: "gap-1 pt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutline/* default */.Z, {
                                    sx: {
                                        color: "#FF7373",
                                        width: {
                                            xs: 15,
                                            sm: 20
                                        },
                                        height: {
                                            xs: 15,
                                            sm: 20
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "text-warm-red text-xs-2 sm:text-sm font-dm_mono_regular",
                                    children: error
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var base_AmountInput = (AmountInput);


/***/ }),

/***/ 76824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50594);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78262);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51233);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12485);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67720);
/* harmony import */ var decimal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90482);
/* harmony import */ var _utils_number_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72199);





const BaseDialog = (param)=>{
    let { title , tokenAvatar , tokenSymbol , titleAmount , body , isOpened , handleClose , ...dialogProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        ...dialogProps,
        open: !!isOpened,
        onClose: handleClose,
        PaperProps: {
            className: "rounded-2xl bg-popup-gradient w-[480px] min-w-[374px]",
            style: {
                border: "1px solid #FFFFFF1F"
            }
        },
        scroll: "paper",
        "aria-labelledby": "scroll-dialog-title",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: "p-4 lg:p-6",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            className: "font-cc text-white uppercase text-sm sm:text-base",
                            sx: {
                                wordSpacing: "0.4rem"
                            },
                            children: title
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: "flex flex-row gap-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    src: tokenAvatar,
                                    alt: tokenSymbol,
                                    sx: {
                                        width: {
                                            xs: 48,
                                            lg: 64
                                        },
                                        height: {
                                            xs: 48,
                                            lg: 64
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            className: "font-dm_mono_regular text-xs-2 sm:text-sm md:text-base text-semi-transparent-white",
                                            children: tokenSymbol
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            className: "font-zen_dot text-base sm:text-lg-2 md:text-2xl text-white",
                                            children: "".concat((0,_utils_number_helpers__WEBPACK_IMPORTED_MODULE_2__/* .format */ .WU)(new decimal_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(titleAmount || 0), true, 2))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            onClick: handleClose,
                            sx: {
                                color: (theme)=>theme.palette.grey[500],
                                alignSelf: "flex-start"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                className: "h-4 w-4 md:h-6 md:w-6"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: "mt-5 w-full",
                    style: {
                        height: "2px",
                        backgroundColor: "rgba(220, 193, 255, 0.08)"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "mt-5",
                    children: body
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseDialog);


/***/ }),

/***/ 12321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75545);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48999);


const BootstrapTooltip = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)((param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...props,
        arrow: true,
        enterTouchDelay: 0,
        classes: {
            popper: className
        }
    });
})((param)=>{
    let { theme  } = param;
    return {
        ["& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"].arrow */ .Z.arrow)]: {
            color: "#DCC1FF"
        },
        ["& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tooltip */ .Z.tooltip)]: {
            backgroundColor: "#DCC1FF",
            color: "#010101A3",
            fontSize: "14px",
            lineHeight: "20px",
            maxWidth: "400px",
            padding: "12px 16px",
            fontFamily: "DM Mono Regular",
            borderRadius: "12px",
            [theme.breakpoints.down("xs")]: {
                fontSize: "12px",
                lineHeight: "18px"
            }
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (BootstrapTooltip);


/***/ }),

/***/ 67814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51233);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_icons_material_HelpOutline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27608);
/* harmony import */ var _components_base_BootstrapTooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12321);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





const IneligibleLCRatio = ()=>{
    const theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const isSmall = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.breakpoints.up("sm"));
    const [iconColor, setIconColor] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("#FFFFFF7A");
    const handleIconClick = ()=>{
        if (!isSmall) {
            // Change icon color when clicked
            setIconColor("#FAFAFA");
            // Revert the color after 2 seconds
            setTimeout(()=>{
                setIconColor("#FFFFFF7A");
            }, 1600);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        direction: "row",
        justifyContent: "space-between",
        className: "py-1.5 lg:py-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "text-white/50 text-xs-2 sm:text-sm font-dm_mono_regular",
                children: "LC ratio"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                direction: "row",
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: "text-light-orange font-dm_mono_regular text-xs-2 sm:text-sm",
                        children: "Ineligible"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_BootstrapTooltip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        title: "Launchpad Credit (LC) is exclusively earned through SOLCAT staking",
                        placement: "top",
                        className: "font-dm_mono_regular",
                        leaveDelay: isSmall ? 0 : 2000,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_HelpOutline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            sx: {
                                color: iconColor,
                                width: 24,
                                height: 24,
                                "&:hover": {
                                    color: {
                                        sm: "#DCC1FF"
                                    }
                                }
                            },
                            className: "cursor-pointer",
                            onClick: handleIconClick
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IneligibleLCRatio);


/***/ }),

/***/ 80390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59653);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51233);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _mui_icons_material_HelpOutline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27608);
/* harmony import */ var _components_base_BootstrapTooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12321);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _providers_solana__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76300);






const CustomSwitch = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((param)=>{
    let { theme  } = param;
    return {
        width: 40,
        height: 24,
        padding: 7,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            top: "50%",
            left: 2,
            transform: "translate(0, -50%)",
            "&.Mui-checked": {
                transform: "translate(20px, -50%)",
                color: "#fff",
                "& .MuiSwitch-thumb": {
                    backgroundColor: "#6DFCD1"
                },
                "& .MuiSwitch-thumb:before": {
                    backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6L9 17l-5-5'/%3E%3C/svg%3E\")"
                },
                "& + .MuiSwitch-track": {
                    backgroundColor: "#3d836f",
                    opacity: 1,
                    border: 0
                }
            }
        },
        "& .MuiSwitch-thumb": {
            width: 16,
            height: 16,
            backgroundColor: "#FAFAFA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:before": {
                content: '""',
                width: "100%",
                height: "100%",
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2301010129' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 18L18 6M6 6l12 12'/%3E%3C/svg%3E\")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "60%"
            }
        },
        "& .MuiSwitch-track": {
            borderRadius: 13,
            backgroundColor: "#818081",
            opacity: 1
        }
    };
});
const JitoValidatorSwitch = ()=>{
    const theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const isSmall = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(theme.breakpoints.up("sm"));
    const [iconColor, setIconColor] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("#FFFFFF7A");
    const { usingJitoValidator , setUsingJitoValidator  } = (0,_providers_solana__WEBPACK_IMPORTED_MODULE_3__/* .useSolana */ .X)();
    const handleSwitchChange = (event)=>{
        setUsingJitoValidator && setUsingJitoValidator(event.target.checked);
    };
    const handleIconClick = ()=>{
        if (!isSmall) {
            // Change icon color when clicked
            setIconColor("#FAFAFA");
            // Revert the color after 2 seconds
            setTimeout(()=>{
                setIconColor("#FFFFFF7A");
            }, 1600);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        direction: "row",
        justifyContent: "space-between",
        className: "py-0.5 lg:py-1.5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: "flex flex-row gap-1 items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        className: "text-white/50 text-xs-2 sm:text-sm font-dm_mono_regular",
                        children: "Use Jito"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_BootstrapTooltip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        title: "Use Jito for faster transactions during Solana congestion!",
                        placement: "top",
                        className: "font-dm_mono_regular",
                        leaveDelay: isSmall ? 0 : 2000,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_HelpOutline__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            sx: {
                                color: iconColor,
                                width: 24,
                                height: 24,
                                "&:hover": {
                                    color: {
                                        sm: "#DCC1FF"
                                    }
                                }
                            },
                            className: "cursor-pointer",
                            onClick: handleIconClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomSwitch, {
                checked: usingJitoValidator,
                size: "small",
                onChange: handleSwitchChange
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (JitoValidatorSwitch);


/***/ }),

/***/ 32857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(34155);



const Seo = (param)=>{
    let { data  } = param;
    const { title , description , url , thumbnailUrl  } = data;
    const ahrefMetaContent = process.env.NEXT_PUBLIC_AHREF_META;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: thumbnailUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: thumbnailUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ahrefs-site-verification",
                content: ahrefMetaContent
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Seo);


/***/ }),

/***/ 63378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ flexible_apy_dialog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/components/base/AmountInput.tsx + 1 modules
var AmountInput = __webpack_require__(11653);
// EXTERNAL MODULE: ./src/components/base/BaseDialog.tsx
var BaseDialog = __webpack_require__(76824);
// EXTERNAL MODULE: ./src/components/base/Button.tsx
var Button = __webpack_require__(2546);
// EXTERNAL MODULE: ./node_modules/bn.js/lib/bn.js
var bn = __webpack_require__(13550);
var bn_default = /*#__PURE__*/__webpack_require__.n(bn);
// EXTERNAL MODULE: ./src/providers/solana/index.tsx + 2 modules
var solana = __webpack_require__(76300);
// EXTERNAL MODULE: ./src/utils/bn-utils.ts
var bn_utils = __webpack_require__(97087);
// EXTERNAL MODULE: ./node_modules/@solana/web3.js/lib/index.browser.esm.js + 15 modules
var index_browser_esm = __webpack_require__(96737);
// EXTERNAL MODULE: ./src/hooks/use-projects.ts + 1 modules
var use_projects = __webpack_require__(75479);
// EXTERNAL MODULE: ./src/utils/apis/staking-positions.ts
var staking_positions = __webpack_require__(79155);
// EXTERNAL MODULE: ./src/utils/fetch-projects.ts
var fetch_projects = __webpack_require__(97531);
// EXTERNAL MODULE: ./node_modules/bs58/index.js
var bs58 = __webpack_require__(77191);
var bs58_default = /*#__PURE__*/__webpack_require__.n(bs58);
;// CONCATENATED MODULE: ./src/hooks/use-stake.ts









function useStake() {
    const { stakingClient , connection , publicKey , signTransaction , usingJitoValidator , jitoClient , jitoTipAmount  } = (0,solana/* useSolana */.X)();
    const queryClient = (0,es.useQueryClient)();
    const { projects  } = (0,use_projects/* useProjects */.Z)();
    const mutation = (0,es.useMutation)(async (param)=>{
        let [tokenAddress, amount] = param;
        if (!stakingClient || !connection || !publicKey || !signTransaction) {
            return;
        }
        const project = projects.find((project)=>project.address === tokenAddress);
        if (!project) {
            return;
        }
        const stakeAmount = (0,bn_utils/* convertUIAmountToRawAmount */.z)(amount, project.decimals);
        const tx = await stakingClient.stake(new (bn_default())(stakeAmount), true, new index_browser_esm.PublicKey(tokenAddress));
        if (usingJitoValidator) {
            const randomTipAccount = await jitoClient.getRandomTipAccount();
            const jitoTipAccount = new index_browser_esm.PublicKey(randomTipAccount);
            tx.add(index_browser_esm.SystemProgram.transfer({
                fromPubkey: publicKey,
                toPubkey: jitoTipAccount,
                lamports: jitoTipAmount * index_browser_esm.LAMPORTS_PER_SOL
            }));
        }
        const latestBlockHash = await connection.getLatestBlockhash();
        tx.recentBlockhash = latestBlockHash.blockhash;
        tx.feePayer = publicKey;
        const signedTx = await signTransaction(tx);
        const serializedTx = signedTx.serialize();
        let signature;
        if (usingJitoValidator) {
            const result = await jitoClient.sendTxn([
                bs58_default().encode(new Uint8Array(serializedTx))
            ], false);
            signature = result === null || result === void 0 ? void 0 : result.result;
        } else {
            signature = await connection.sendRawTransaction(serializedTx);
        }
        await connection.confirmTransaction({
            blockhash: latestBlockHash.blockhash,
            lastValidBlockHeight: latestBlockHash.lastValidBlockHeight,
            signature: signature
        });
        return signature;
    }, {
        onSuccess: async (signature, param)=>{
            let [tokenAddress, amount] = param;
            queryClient.invalidateQueries([
                "userFlexibleStakingInfo",
                publicKey
            ]);
            queryClient.invalidateQueries([
                "protocolBasicInfo",
                tokenAddress
            ]);
            queryClient.invalidateQueries([
                "tokenBalance",
                tokenAddress,
                (publicKey === null || publicKey === void 0 ? void 0 : publicKey.toString()) || ""
            ]);
            const project = (0,fetch_projects/* getProjectByAddress */.M)(tokenAddress);
            if (project && signature) {
                // Log staking position
                await (0,staking_positions/* logStakingPosition */.x)({
                    wallet_address: (publicKey === null || publicKey === void 0 ? void 0 : publicKey.toString()) || "",
                    action: "deposit",
                    amount: Number(amount),
                    tx_hash: signature,
                    symbol: project.symbol,
                    stake_type: "flexible",
                    vault_index: 0
                });
            }
        }
    });
    return mutation;
}

// EXTERNAL MODULE: ./src/hooks/use-token-balance.ts
var use_token_balance = __webpack_require__(71115);
// EXTERNAL MODULE: ./src/utils/apis/setting.ts
var setting = __webpack_require__(99476);
// EXTERNAL MODULE: ./src/utils/number-helpers.ts
var number_helpers = __webpack_require__(72199);
// EXTERNAL MODULE: ./src/utils/staking-helpers.ts
var staking_helpers = __webpack_require__(96395);
// EXTERNAL MODULE: ./src/utils/time-helpers.ts
var time_helpers = __webpack_require__(27034);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@solana/wallet-adapter-react/lib/esm/useWallet.js
var useWallet = __webpack_require__(54306);
// EXTERNAL MODULE: ./src/components/connect-wallet/index.ts + 2 modules
var connect_wallet = __webpack_require__(37131);
// EXTERNAL MODULE: ./src/components/base/IneligibleLCRatio.tsx
var IneligibleLCRatio = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(73680);
// EXTERNAL MODULE: ./src/hooks/use-protocol-data.ts
var use_protocol_data = __webpack_require__(30777);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/base/JitoValidatorSwitch.tsx
var JitoValidatorSwitch = __webpack_require__(80390);
;// CONCATENATED MODULE: ./src/components/stake/flexible-apy-dialog.tsx




















const mintTextDetails = [
    "Est APR",
    "Est daily reward",
    "LC earning"
];
const FlexibleAPYDialog = (param)=>{
    let { showModal , onClose , tokenAvatar , tokenSymbol , tokenAddress  } = param;
    var _settingData_stake_lc_ratio_json;
    const [amount, setAmount] = (0,react.useState)("");
    const { connected  } = (0,useWallet/* useWallet */.O)();
    const router = (0,next_router.useRouter)();
    const theme = (0,useTheme/* default */.Z)();
    const isSmall = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const { data: tokenBalance  } = (0,use_token_balance/* useTokenBalance */.m)(tokenAddress);
    // const { data: stakingInfo } = useStakingInfo(tokenAddress)
    const { data: protocolData  } = (0,use_protocol_data/* useProtocolData */.r)([
        tokenAddress
    ]);
    const stakingInfo = protocolData === null || protocolData === void 0 ? void 0 : protocolData.stakingInfo[tokenAddress];
    const flexibleApr = stakingInfo === null || stakingInfo === void 0 ? void 0 : stakingInfo.flexibleApr;
    const flexibleWithdrawalDelayTime = stakingInfo === null || stakingInfo === void 0 ? void 0 : stakingInfo.flexibleWithdrawalDelayTime;
    const withdrawDelayDays = (0,time_helpers/* secondsToDays */.i)(Number(flexibleWithdrawalDelayTime) || 0);
    const { data: settingData  } = (0,es.useQuery)({
        queryKey: [
            "setting"
        ],
        queryFn: ()=>(0,setting/* fetchSetting */.j)()
    });
    const isSolcat = (0,helpers/* isSolcatToken */.k0)(tokenSymbol);
    const lcRatio = isSolcat ? settingData === null || settingData === void 0 ? void 0 : (_settingData_stake_lc_ratio_json = settingData.stake_lc_ratio_json) === null || _settingData_stake_lc_ratio_json === void 0 ? void 0 : _settingData_stake_lc_ratio_json.flexible : 0;
    const lcEarning = amount ? Number(lcRatio || 0) * Number(amount) : 0;
    const formattedLcRatio = lcRatio + "x";
    const formattedLcEarning = (0,number_helpers/* format */.WU)(lcEarning, true, 0);
    const estDailyReward = (0,staking_helpers/* calculateEstDailyReward */.yy)((flexibleApr === null || flexibleApr === void 0 ? void 0 : flexibleApr.toString()) || "0", amount || "0");
    const stakeDetails = [
        {
            name: "Est APR",
            value: "".concat((0,number_helpers/* formatPercentage */.rl)((flexibleApr === null || flexibleApr === void 0 ? void 0 : flexibleApr.toString()) || "0", false, 2))
        },
        {
            name: "Unstake delay time",
            value: "".concat(withdrawDelayDays, " days")
        },
        {
            name: "LC ratio",
            value: formattedLcRatio
        },
        ...isSolcat ? [
            {
                name: "LC earning",
                value: formattedLcEarning
            }
        ] : [],
        {
            name: "Est daily reward",
            value: "".concat(estDailyReward, " ").concat(tokenSymbol)
        }
    ];
    const { mutateAsync: stake , isLoading: isLoadingStake  } = useStake();
    const handleCloseModal = (0,react.useCallback)(()=>{
        onClose();
        setAmount("");
        document.body.style.overflow = "auto";
    }, [
        onClose
    ]);
    const handleStake = async ()=>{
        try {
            await stake([
                tokenAddress,
                amount
            ]);
            router.push("/portfolio");
        } catch (error) {
            console.error("Error during staking:", error);
        } finally{
            handleCloseModal();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseDialog/* default */.Z, {
        handleClose: handleCloseModal,
        isOpened: showModal,
        title: "Flexible staking",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AmountInput/* default */.Z, {
                    amount: amount,
                    setAmount: setAmount,
                    balance: tokenBalance,
                    tokenAvatar: tokenAvatar,
                    tokenSymbol: tokenSymbol
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    className: "w-full mt-5",
                    style: {
                        height: "2px",
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    className: "mt-5 px-1",
                    children: [
                        stakeDetails.map((detail, index)=>{
                            if (!isSolcat && detail.name === "LC ratio") return /*#__PURE__*/ (0,jsx_runtime.jsx)(IneligibleLCRatio/* default */.Z, {}, index);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                className: "py-1.5 lg:py-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-white/50 text-xs-2 sm:text-sm font-dm_mono_regular",
                                        children: detail.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "".concat(mintTextDetails.includes(detail.name) ? "text-mint-green" : "text-white", " text-xs-2 sm:text-sm font-dm_mono_regular"),
                                        children: detail.value
                                    })
                                ]
                            }, index);
                        }),
                        connected && /*#__PURE__*/ (0,jsx_runtime.jsx)(JitoValidatorSwitch/* default */.Z, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    className: "w-full my-5",
                    style: {
                        height: "2px",
                        backgroundColor: "rgba(255, 255, 255, 0.08)"
                    }
                }),
                !connected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    onClick: ()=>handleCloseModal(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(connect_wallet/* default */.Z, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: !connected || !amount || Number(amount) > Number(tokenBalance),
                    customVariant: "emphasis",
                    fontSize: isSmall ? "base" : "sm",
                    onClick: handleStake,
                    isLoading: isLoadingStake,
                    className: "px-6 py-3",
                    children: "Stake"
                })
            ]
        })
    });
};
/* harmony default export */ var flexible_apy_dialog = (FlexibleAPYDialog);


/***/ }),

/***/ 30777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useProtocolData; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var _providers_solana__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76300);
/* harmony import */ var _catsolhat_staking_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20074);
/* harmony import */ var _catsolhat_staking_sdk__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_catsolhat_staking_sdk__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _solana_web3_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96737);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73680);





const useProtocolData = function() {
    let tokenAddresses = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const { connection  } = (0,_providers_solana__WEBPACK_IMPORTED_MODULE_1__/* .useSolana */ .X)();
    const fetchProtocolData = async ()=>{
        if (!connection || tokenAddresses.length === 0) return;
        const solcatTokens = tokenAddresses.filter(_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSolcatTokenAddress */ .xg);
        const regularTokens = tokenAddresses.filter((address)=>!(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isSolcatTokenAddress */ .xg)(address));
        const v1Result = solcatTokens.length > 0 ? await (0,_catsolhat_staking_sdk__WEBPACK_IMPORTED_MODULE_2__.getProtocolInfo)(connection, false, solcatTokens.map((address)=>new _solana_web3_js__WEBPACK_IMPORTED_MODULE_3__.PublicKey(address))) : null;
        const v2Result = regularTokens.length > 0 ? await (0,_catsolhat_staking_sdk__WEBPACK_IMPORTED_MODULE_2__.getProtocolInfo)(connection, true, regularTokens.map((address)=>new _solana_web3_js__WEBPACK_IMPORTED_MODULE_3__.PublicKey(address))) : null;
        const v1ResultTransformed = v1Result ? transformV1ToV2Format(v1Result) : null;
        const result = {
            admin: v2Result === null || v2Result === void 0 ? void 0 : v2Result.admin,
            stakingInfo: {
                ...v2Result === null || v2Result === void 0 ? void 0 : v2Result.stakingInfo,
                ...v1ResultTransformed === null || v1ResultTransformed === void 0 ? void 0 : v1ResultTransformed.stakingInfo
            }
        };
        return result;
    };
    const tokenCacheKey = tokenAddresses.length > 0 ? tokenAddresses.join(",") : "all_tokens";
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)([
        "protocolBasicInfo",
        tokenCacheKey
    ], fetchProtocolData, {
        enabled: !!connection
    });
};
const transformV1ToV2Format = (v1Data)=>{
    return {
        admin: v1Data.admin,
        stakingInfo: {
            [v1Data.mint]: {
                flexibleRewardRate: v1Data.flexibleRewardRate,
                flexibleApr: v1Data.flexibleApr,
                flexibleWithdrawalDelayTime: v1Data.flexibleWithdrawalDelayTime,
                lockupApy: v1Data.lockupApy,
                lockupDuration: v1Data.lockupDuration,
                minLockupAmount: v1Data.minLockupAmount
            }
        }
    };
};


/***/ }),

/***/ 942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_trans; }
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/locales/en.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const locale = {
    BODO: {
        website_url: "https://boopdoge.com/",
        telegram_url: "https://t.me/BoopDoge_Token",
        x_url: "https://x.com/BoopDoge_Token",
        guide_url: "https://catsolhat.medium.com/introducing-the-first-catsolhat-launchpad-project-boopdoge-4e136347e53f",
        description: "<p>BoopDoge is a community-driven meme coin inspired by the urge to boop a dog on the nose. Our mission is to help passionate dog lovers and crypto enthusiasts achieve financial freedom.</p> <p>BoopDoge will be a flagship for emerging DeFi and meme culture on Solana. This is part of a larger plan to strengthen the creator culture on Solana as BoopDoge continues to integrate into the broader ecosystem.</p>",
        eligibility: (eligibleAmount)=>'<p>Average holding of at <span style="color:#6dfcd1">least '.concat(eligibleAmount, " SOLCAT</span> (based on two snapshots).       The first snapshot was taken on 1st July. The second snapshot will be taken at a random moment between 6th and 8th July.</p>"),
        token_name: "BoopDoge",
        blockchain: "Solana"
    },
    meta: {
        title: "CatSolHat Super Airdrop",
        description: "Claim your SOLCAT airdrop: Early Contributors, Active Wallets on Solana DEXs, Saga Phone Buyers, Top NFT Collections Holders,...",
        thumbnail_url: "/thumbnail.png"
    },
    instruction: {
        stake_solcat: {
            title: "Get SOLCAT & Connect",
            description: '<p style="margin:0">Grab your SOLCAT from any DEX. Then, connect your wallet to the staking platform and click <br/> <span class="font-dm_mono" style="color:#6dfcd1">STAKE NOW</span>.</p>'
        },
        staking_plan: {
            title: "Choose Your Staking Plan",
            description: '<p style="margin:0">Choose between two staking options: <span class="font-dm_mono" style="color:#6dfcd1">Flexible</span> and <span class="font-dm_mono" style="color:#6dfcd1">Fixed</span>. Both offer great interest rates and earn you Launchpad Credit (LC).</p>'
        },
        reward: {
            title: "Unlock Max Rewards",
            description: '<p style="margin:0">Fixed staking gives the highest interest rates and <span class="font-dm_mono" style="color:#6dfcd1">multiplied LC</span>, boosting your eligibility for launchpad presales and airdrops.</p>'
        }
    }
};
/* harmony default export */ var en = (locale);

;// CONCATENATED MODULE: ./src/hooks/use-trans.ts


const useTrans = ()=>{
    const { locale  } = (0,router.useRouter)();
    switch(locale){
        default:
            return en;
    }
};
/* harmony default export */ var use_trans = (useTrans);


/***/ }),

/***/ 99476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ fetchSetting; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87066);

async function fetchSetting() {
    const response = await axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat("https://api.catsolhat.com/api/v1", "/settings"));
    return {
        stake_lc_ratio_json: response.data.stake_lc_ratio_json
    };
}


/***/ }),

/***/ 79155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ logStakingPosition; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4640);

async function logStakingPosition(params) {
    return await (0,___WEBPACK_IMPORTED_MODULE_0__/* .postToApi */ .I$)("/staking/positions", params);
}


/***/ }),

/***/ 96395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A1": function() { return /* binding */ formatFixStakedPosition; },
/* harmony export */   "Pw": function() { return /* binding */ convertOnChainFixedAprToPercentage; },
/* harmony export */   "RZ": function() { return /* binding */ calculateEstFixedReward; },
/* harmony export */   "W3": function() { return /* binding */ formatUnstakePosition; },
/* harmony export */   "in": function() { return /* binding */ formatFlexStakedPosition; },
/* harmony export */   "yy": function() { return /* binding */ calculateEstDailyReward; }
/* harmony export */ });
/* unused harmony exports checkIfLockupStaked, checkIfExistUnstakePosition */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1880);
/* harmony import */ var _number_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72199);
/* harmony import */ var _time_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27034);



const checkIfLockupStaked = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
lockupStakingInfo, connected)=>{
    var _lockupStakingInfo_lockupStakingAccounts;
    return connected && !!(lockupStakingInfo === null || lockupStakingInfo === void 0 ? void 0 : (_lockupStakingInfo_lockupStakingAccounts = lockupStakingInfo.lockupStakingAccounts) === null || _lockupStakingInfo_lockupStakingAccounts === void 0 ? void 0 : _lockupStakingInfo_lockupStakingAccounts.length);
};
const checkIfExistUnstakePosition = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
userFlexibleStakingInfo, connected)=>{
    var _userFlexibleStakingInfo_withdrawPositions;
    return connected && !!(userFlexibleStakingInfo === null || userFlexibleStakingInfo === void 0 ? void 0 : (_userFlexibleStakingInfo_withdrawPositions = userFlexibleStakingInfo.withdrawPositions) === null || _userFlexibleStakingInfo_withdrawPositions === void 0 ? void 0 : _userFlexibleStakingInfo_withdrawPositions.length);
};
const convertOnChainFixedAprToPercentage = (apr)=>{
    // 5% fixed apr -> 500 on chain
    return apr / 10000;
};
const calculateEstDailyReward = (apr, stakedAmount)=>{
    const dailyReward = Number(apr) / 100 / 365 * Number(stakedAmount);
    return dailyReward.toFixed(2);
};
const calculateEstFixedReward = (aprInPercentage, stakedAmount, durationInSeconds)=>{
    const dailyReward = aprInPercentage / _constants__WEBPACK_IMPORTED_MODULE_0__/* .DAYS_PER_YEAR */ ._G * stakedAmount;
    return dailyReward * (durationInSeconds / _constants__WEBPACK_IMPORTED_MODULE_0__/* .SECOND_PER_DAY */ .rw);
};
const formatFixStakedPosition = (position)=>{
    return {
        ...position,
        formattedLockedAmount: (0,_number_helpers__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(position.lockedAmount, true, 2),
        formattedEstApr: (0,_number_helpers__WEBPACK_IMPORTED_MODULE_1__/* .formatPercentage */ .rl)(position.estApr * 100, false, 2),
        formattedLockPeriod: (0,_time_helpers__WEBPACK_IMPORTED_MODULE_2__/* .secondsToDays */ .i)(position.lockPeriodInSeconds) + " days",
        formattedRemainingTime: (0,_time_helpers__WEBPACK_IMPORTED_MODULE_2__/* .formatRemainingTime */ .d)(position.remainingSeconds),
        formattedEstReward: (0,_number_helpers__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(position.estReward, true, 4) + " " + position.tokenSymbol
    };
};
const formatFlexStakedPosition = (position)=>{
    return {
        ...position,
        formattedAmount: (0,_number_helpers__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(position.amount, true, 2),
        formattedEstApr: (0,_number_helpers__WEBPACK_IMPORTED_MODULE_1__/* .formatPercentage */ .rl)(position.estApr, false, 2),
        formattedEstReward: (0,_number_helpers__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(position.estReward, true, 4) + " " + position.tokenSymbol,
        formattedRemainingTime: (0,_time_helpers__WEBPACK_IMPORTED_MODULE_2__/* .formatRemainingTime */ .d)(position.remainingSeconds)
    };
};
const formatUnstakePosition = (position)=>{
    return {
        ...position,
        formattedRemainingTime: (0,_time_helpers__WEBPACK_IMPORTED_MODULE_2__/* .formatRemainingTime */ .d)(position.remainingSeconds)
    };
};


/***/ }),

/***/ 27034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ formatRemainingTime; },
/* harmony export */   "i": function() { return /* binding */ secondsToDays; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1880);

const secondsToDays = (seconds)=>{
    return Math.floor(seconds / (24 * 60 * 60));
};
const formatRemainingTime = (remainingSeconds)=>{
    const remainingDays = Math.ceil(remainingSeconds / _constants__WEBPACK_IMPORTED_MODULE_0__/* .SECOND_PER_DAY */ .rw);
    if (remainingDays > 1) {
        return "".concat(remainingDays, " days");
    }
    const remainingHours = Math.max(Math.ceil(remainingSeconds / 3600), 0);
    return "".concat(remainingHours, " ").concat(remainingHours > 1 ? "hours" : "hour");
};


/***/ })

}]);